export default __webpack_public_path__ + "static/media/torusIcon.e018ac64.png";